// -----------------------------------------------------------------------------
// core/commands/project-commands.ts — undoable changes to project-level settings.
//
// Canvas size (aspect ratio), background colour, fps and name. Captures the prior
// values so undo restores them. The engine reacts to size/background changes by
// resizing the preview compositor and re-clearing to the new colour.
// -----------------------------------------------------------------------------
import type { Command } from '../commands';
import type { Project } from '../model';
import type { EditorState } from '../store';

export type ProjectPatch = Partial<Pick<Project, 'name' | 'width' | 'height' | 'fps' | 'background'>>;

export class UpdateProjectCommand implements Command {
  readonly label = 'Project settings';
  private prev: Record<string, unknown> = {};
  constructor(private readonly patch: ProjectPatch) {}
  do(state: EditorState): void {
    const project = state.project as unknown as Record<string, unknown>;
    this.prev = {};
    for (const key of Object.keys(this.patch)) {
      this.prev[key] = project[key];
      project[key] = (this.patch as Record<string, unknown>)[key];
    }
  }
  undo(state: EditorState): void {
    const project = state.project as unknown as Record<string, unknown>;
    for (const key of Object.keys(this.prev)) project[key] = this.prev[key];
  }
}
